module.exports = __webpack_public_path__ + "static/media/cross.59f8f0d2.svg";